import { render, staticRenderFns } from "./Forgotten.vue?vue&type=template&id=12880655&scoped=true"
import script from "./Forgotten.vue?vue&type=script&lang=js"
export * from "./Forgotten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12880655",
  null
  
)

export default component.exports